import React, { useEffect, useState } from "react";
import { Container, Grid } from "@mui/material";
import WebFont from "webfontloader";
import { useSearchParams } from "react-router-dom";
import { getAddressUpdateAPI } from "../utiils/api";
import Header from "./common/Header/index";
import OrderDetails from "./OrderDetails/index";
import AddressUpdate from "./AddressUpdate/index";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GridLoader } from "react-spinners";
import ErrorPage from "./ErrorPages";

function UpdateAddressWrapper() {
  const [loading, setLoading] = useState(true);
  const [brandConfig, setBrandConfig] = useState(null);
  const [order, setOrder] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [validationConfig, setValidationConfig] = useState(null);
  const [addressBucket, setAddressBucket] = useState(null);
  const [updatedAddress, setUpdatedAddress] = useState(null);
  const [params, setParams] = useSearchParams();
  const identifier = params.get("bucketidentifier");
  const order_id = params.get("storeorderid");
  const [invalidPage, setInvalidPage] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    getAddressUpdateAPI(identifier, order_id)
      .then((resp) => {
        setLoading(false);
        setBrandConfig(resp.data.data.brand_config);
        if (
          resp.data?.data.brand_config.google_font_family &&
          resp.data.data.brand_config.google_font_family !== null &&
          resp.data.data.brand_config.google_font_family !== ""
        ) {
          WebFont.load({
            google: {
              families: [resp.data.data.brand_config.google_font_family],
            },
          });
        }
        setOrder(resp.data.data.order);
        setShippingAddress(resp.data.data.shipping_address);
        setValidationConfig(resp.data.data.validation_config);
        setAddressBucket(resp.data.data.address_bucket);
        setUpdatedAddress(resp.data.data.corrected_order_info);
      })
      .catch((err) => {
        setInvalidPage(true);
        setError(err.response);
      });
  }, []);

  useEffect(() => {
    var link = document.querySelector("link[rel~='icon']");
    var title = document.getElementsByTagName("title")[0];
    var description = document.querySelector("meta[name~='description']");
    var ogtitle = document.querySelector("meta[name~='og:title']");
    var ogdescription = document.querySelector("meta[name~='og:description']");
    var ogimage = document.querySelector("meta[name~='og:image']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }

    if (!title) {
      title = document.createElement("title");
      document.getElementsByTagName("head")[0].appendChild(title);
    }

    if (!description) {
      description = document.createElement("meta");
      description.name = "description";
      document.getElementsByTagName("head")[0].appendChild(description);
    }

    if (!ogtitle) {
      ogtitle = document.createElement("meta");
      ogtitle.name = "og:title";
      document.getElementsByTagName("head")[0].appendChild(ogtitle);
    }

    if (!ogdescription) {
      ogdescription = document.createElement("meta");
      ogdescription.name = "og:description";
      document.getElementsByTagName("head")[0].appendChild(ogdescription);
    }

    if (!ogimage) {
      ogimage = document.createElement("meta");
      ogimage.name = "og:image";
      document.getElementsByTagName("head")[0].appendChild(ogimage);
    }

    try {
      if (brandConfig && brandConfig !== null) {
        link.href = brandConfig.favicon;
        title.innerText = ogtitle.content = `Update Address - ${
          brandConfig.shop_name !== undefined
            ? brandConfig.shop_name
            : " Pragma"
        }`;
        ogdescription.content = description.content =
          "A website to update address of your orders. Powered by Pragma";
        ogimage.content = brandConfig.brand_logo;
      }
    } catch (err) {
      console.log("Unable to update brand config", err);
    }
  }, [brandConfig]);

  return (
    <div>
      {loading ? (
        invalidPage && error !== null ? (
          <ErrorPage error={error} />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <GridLoader color="#1d8dcc" size={20} />
          </div>
        )
      ) : (
        <div style={{ background: "#EEEEEE", minHeight: "100vh" }}>
          <ToastContainer />
          <Header brandConfig={brandConfig} />
          <Container
            className="card-wrapper"
            fixed
            style={{
              maxWidth: "1500px",
              fontFamily:
                brandConfig &&
                brandConfig.google_font_family !== null &&
                brandConfig.google_font_family !== ""
                  ? brandConfig.google_font_family
                  : "Poppins,sans-serif",
            }}
          >
            <p
              style={{
                fontSize: "20px",
                color: "#333",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Hello {order && order !== null && order.customer_first_name}{" "}
              {order && order !== null && order.customer_last_name} 👋
            </p>
            <Grid
              container
              gridTemplateColumns="repeat(12, 1fr)"
              style={{ marginTop: "20px" }}
            >
              <Grid className="order-grid" item xs={12} md={6}>
                <OrderDetails order={order} shippingAddress={shippingAddress} />
              </Grid>
              <Grid className="address-grid" item xs={12} md={6}>
                <AddressUpdate
                  brandConfig={brandConfig}
                  validationConfig={validationConfig}
                  order={order}
                  addressBucket={addressBucket}
                  updatedAddress={updatedAddress}
                  setUpdatedAddress={setUpdatedAddress}
                  setAddressBucket={setAddressBucket}
                />
              </Grid>
            </Grid>
          </Container>
        </div>
      )}
    </div>
  );
}

export default UpdateAddressWrapper;
